/* eslint-disable max-len */
export const IntersectionObserverFunction = (

	lastElementRef:any,
	LoadMore : () => void
) =>
{
	if (lastElementRef?.current)
	{
		const observer = new IntersectionObserver(
			([ entry ]) =>
			{
				if (entry.isIntersecting)
				{
					LoadMore();
				}
			},
			{
				root       : null,
				rootMargin : '0px',
				threshold  : 0.0
			}
		);

		if (lastElementRef.current)
		{
			observer.observe(lastElementRef.current);
		}

		return () =>
		{
			if (lastElementRef.current)
			{
				observer.unobserve(lastElementRef.current);
			}
		};
	}
};

export const IntersectionObserverFunctionHorVert = (

	lastEleRef:any,
	lastHorRef:any,
	LoadMore : () => void
) =>
{
	if (lastEleRef.current || lastHorRef.current)

	{
		const observer = new IntersectionObserver((entries) =>
		{
			if (entries[0]?.isIntersecting)
			{
				LoadMore();
			}
		}, {
			root       : null,
			rootMargin : '0px',
			threshold  : 0.5

		});

		if (lastEleRef.current || lastHorRef.current)
		{
			observer.observe(lastEleRef.current);
			observer.observe(lastHorRef.current);
		}

		return () =>
		{
			if (lastEleRef?.current || lastHorRef.current)
			{
				observer.unobserve(lastEleRef.current);
				observer.unobserve(lastHorRef.current);
			}
		};
	}
};